/**
 * Labstep
 *
 * @module core/Collapsible
 * @desc Collapsible component
 */

import { Icon } from 'labstep-web/core/Icon';
import { useToggle } from 'labstep-web/hooks/toggle';
import type React from 'react';
import styles from './styles.module.scss';
import type { ICollapsibleProps } from './types';

export const Collapsible: React.FC<ICollapsibleProps> = ({
  label,
  component,
  initialExpandedState = false,
  withChevron = true,
  dataCy,
}) => {
  const [expanded, toggleExpanded] = useToggle(initialExpandedState);
  return (
    <div>
      <div
        data-cy={dataCy}
        className={styles.clickable}
        onClick={toggleExpanded}
      >
        {typeof label === 'function' ? label(expanded) : label}
        {withChevron && (
          <Icon name={expanded ? 'chevron up' : 'chevron down'} />
        )}
      </div>
      {expanded && component}
    </div>
  );
};
